module.exports = __webpack_public_path__ + "img/1536474912.2e709eb5.jpg";